import React, { useState, useEffect, useRef } from 'react';
import './productDetail.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Header from '../components/headerBar';
import Footer from '../components/footer';
import { Row, Col, Tooltip } from 'antd';
import { getProductById, getRelationProducts } from '../api/product';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import QQ_ICON from '../assets/contact/qq.png';
import IMG_DEFAULT_DETAIL from '../assets/default-detail.png';
import IMG_DEFAULT_RELATION from '../assets/default_relation.png';
import Slider from 'react-slick';

interface IProduct {
  backgroundPicUrl: string;
  boilingPoint: string;
  casNo: string;
  catalogId: number;
  einecsNo: string;
  density: string;
  id: number;
  isRecommend: number;
  mdlNo: string;
  meltingPoint: string;
  molecularFormula: string;
  molecularWeight: string;
  nameCn: string;
  nameEn: string;
  picUrl: string;
  picDetailUrl: string;
  picRelaUrl: string;
  productNo: string;
  properties: string;
  purity: string;
  status: number;
  storageConditions: string;
  topicPicUrl: string;
  firstCatalogId: number;
  firstCatalogName: string;
  secondCatalogId: number;
  secondCatalogName: string;
  nameAlias: string;
}

const map = Object.freeze({
  a: {
    en: 'Details',
    'zh-cn': '产品详情',
  },
  b: {
    en: 'purity',
    'zh-cn': '纯度',
  },
  c: {
    en: 'properties',
    'zh-cn': '物化性质',
  },
  d: {
    en: 'melting point',
    'zh-cn': '熔点',
  },
  e: {
    en: 'boiling point',
    'zh-cn': '沸点',
  },
  h: {
    en: 'Introduction',
    'zh-cn': '产品信息',
  },
  i: {
    en: 'code',
    'zh-cn': '产品编号',
  },
  j: {
    en: 'cas',
    'zh-cn': 'CAS号',
  },
  k: {
    en: 'alias',
    'zh-cn': '产品别名',
  },
  l: {
    en: 'formula',
    'zh-cn': '分子式',
  },
  m: {
    en: 'weight',
    'zh-cn': '分子量',
  },
  n: {
    en: 'density',
    'zh-cn': '密度',
  },
  o: {
    en: 'einecs',
    'zh-cn': 'EINECS号',
  },
  p: {
    en: 'mdl',
    'zh-cn': 'MDL号',
  },
  q: {
    en: 'storage',
    'zh-cn': '储存条件',
  },
  r: {
    en: 'Suggestion',
    'zh-cn': '相关推荐',
  },
  s: {
    en: 'Product Center',
    'zh-cn': '产品中心',
  },
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ProductDetail = () => {
  const [product, setProduct] = useState<IProduct>();
  const [recommendList, setRecommendList] = useState([]);
  const [slider, setSlider] = useState<Slider | null>();
  const history = useHistory();
  const location = useLocation();
  let { id } = useParams();

  const [la, setLa] = useState<'en' | 'zh-cn'>('zh-cn');

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  const query = useQuery();

  const goProductDetail = (id: number) => history.push(`/${la}/product/${id}`);

  const goProduct = (id?: number, level?: number) => {
    if (id) {
      if (level === 1) {
        history.push(`/${la}/product?type=` + id);
      } else if (level === 2) {
        history.push(`/${la}/product?type=${product?.firstCatalogId}&secondType=${product?.secondCatalogId}`);
      }
    } else {
      history.push(`/${la}/product`);
    }
  };

  const next = () => {
    if (slider) slider.slickNext();
  };
  const previous = () => {
    if (slider) slider.slickPrev();
  };

  useEffect(() => {
    getProductById(id).then((res) => {
      if (res.status === 200) {
        setProduct(res.data);
      }
    });
    getRelationProducts(id).then((res) => {
      if (res.status === 200) {
        setRecommendList(res.data);
      }
    });
  }, []);

  const { lang } = useParams();
  useEffect(() => {
    setLa(lang || 'en');
  }, [location.pathname]);

  useEffect(() => {
    getProductById(id).then((res) => {
      if (res.status === 200) {
        setProduct(res.data);
      }
    });
    getRelationProducts(id).then((res) => {
      if (res.status === 200) {
        setRecommendList(res.data);
      }
    });
  }, [location.pathname]);

  return (
    <div id='product-detail'>
      <Header></Header>
      <ul className='bread-crumbs'>
        <li onClick={() => goProduct()}>{map.s[la]} &gt; &nbsp;</li>
        <li onClick={() => goProduct(product?.firstCatalogId, 1)}>{product?.firstCatalogName} &gt; &nbsp;</li>
        {product?.secondCatalogId && (
          <li onClick={() => goProduct(product?.secondCatalogId, 2)}>{product?.secondCatalogName} &gt; &nbsp;</li>
        )}
        <li> {product?.nameCn}</li>
      </ul>
      <div className='product-info'>
        <div className='title'>{map.h[la]}</div>
        <div className='product-container'>
          <div className='product-img'>
            <img src={product?.picDetailUrl || IMG_DEFAULT_DETAIL} alt='' />
          </div>
          <div className='product-info-detail'>
            <div className='first'>
              <div className='title-container'>
                <div className='title-cn'>{product?.nameCn}</div>
                <div className='title-en'>{product?.nameEn}</div>
              </div>
              <div className='contact'>
                <a href='tencent://message/?uin=3007939906&Site=Sambow&Menu=yes'>
                  <img src={QQ_ICON} alt='' />
                </a>
              </div>
            </div>
            <div className='second'>
              <Row justify='start' gutter={[11, 11]}>
                <Col span={12}>
                  {map.i[la]}：{product?.productNo}
                </Col>
                <Col span={12}>
                  {map.j[la]}：{product?.casNo}
                </Col>
              </Row>
              <Row justify='start' gutter={[11, 11]}>
                <Tooltip title={product?.nameAlias}>
                  <Col span={12} className='namealias'>
                    {map.k[la]}：{product?.nameAlias}
                  </Col>
                </Tooltip>
                <Col span={12}>
                  {map.l[la]}：{product?.molecularFormula}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>

      <div className='product-detail'>
        <div className='title'>{map.a[la]}</div>
        <div className='product-detail-container'>
          <div className='table'>
            <div className='col'>
              <div className='dark'>{map.m[la]}</div>
              <div className='light'>{product?.molecularWeight}</div>
            </div>
            <div className='col'>
              <div className='dark'>{map.d[la]}</div>
              <div className='light'>{product?.meltingPoint}</div>
            </div>
            <div className='col'>
              <div className='dark border'>{map.o[la]}</div>
              <div className='light border'>{product?.einecsNo}</div>
            </div>
          </div>

          <div className='table'>
            <div className='col'>
              <div className='dark'>{map.b[la]}</div>
              <div className='light'>{product?.purity}</div>
            </div>
            <div className='col'>
              <div className='dark'>{map.e[la]}</div>
              <div className='light'>{product?.boilingPoint}</div>
            </div>
            <div className='col'>
              <div className='dark border'>{map.p[la]}</div>
              <div className='light border'>{product?.mdlNo}</div>
            </div>
          </div>

          <div className='table'>
            <div className='col'>
              <div className='dark'>{map.c[la]}</div>
              <div className='light'>{product?.properties}</div>
            </div>
            <div className='col'>
              <div className='dark'>{map.n[la]}</div>
              <div className='light'>{product?.density}</div>
            </div>
            <div className='col'>
              <div className='dark border'>{map.q[la]}</div>
              <div className='light border'>{product?.storageConditions}</div>
            </div>
          </div>
        </div>
      </div>

      <div className='product-recommend'>
        <div className='title'>
          <div className='text'>{map.r[la]}</div>{' '}
          <div className='pagination'>
            <span onClick={previous} className='arrow'>
              &lt; &nbsp;
            </span>
            <span onClick={next} className='arrow'>
              &nbsp; &gt;
            </span>
          </div>
        </div>
        <div className='product-recommend-container'>
          <Slider {...settings} ref={(e) => setSlider(e)}>
            {recommendList.map((recommend: IProduct) => (
              <div
                className='recommend-list-container'
                key={recommend.id}
                onClick={() => goProductDetail(recommend.id)}
              >
                <div className='img-container'>
                  <img src={recommend.picRelaUrl || IMG_DEFAULT_RELATION} alt='' />
                </div>
                <div className='intro'>
                  <Tooltip title={recommend.nameEn}>
                    <div className='name-en'>{recommend.nameEn}</div>
                  </Tooltip>
                  <Tooltip title={recommend.nameCn}>
                    <div className='name-cn'>{recommend.nameCn}</div>
                  </Tooltip>
                  <Tooltip title={recommend.productNo}>
                    <div className='product-no'>{recommend.productNo}</div>
                  </Tooltip>
                  <Tooltip title={recommend.casNo}>
                    <div className='cas-no'>{recommend.casNo}</div>
                  </Tooltip>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default ProductDetail;
